export default __webpack_public_path__ + "static/media/HelveticaNowText-Bold.fd12caa9.otf";